import type {
  Block,
  Document,
  Inline,
  Text
} from '@contentful/rich-text-types';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';

type RichTextNode = Block | Inline | Text;

/**
 * Returns true when dictionary rich text contains embedded entries that
 * `documentToHtmlString` cannot render (e.g. images). Those need
 * `DictionaryRichText` / `LibRichTextRenderer` instead of HTML tooltips.
 */
export function richTextNeedsComponentRenderer(document: Document): boolean {
  return containsEmbeddedEntry(document.content);
}

function containsEmbeddedEntry(nodes: RichTextNode[]): boolean {
  for (const node of nodes) {
    if (
      node.nodeType === BLOCKS.EMBEDDED_ENTRY ||
      node.nodeType === INLINES.EMBEDDED_ENTRY
    ) {
      return true;
    }

    if ('content' in node && Array.isArray(node.content)) {
      if (containsEmbeddedEntry(node.content as RichTextNode[])) {
        return true;
      }
    }
  }

  return false;
}
